module.exports = __webpack_public_path__ + "static/media/logo_mark_only@2x.a10ff43f.png";